import React, { Fragment, useRef, useEffect } from "react";
import { FieldArray, useFormikContext } from "formik";
import ShippingRateNew from "./ShippingRateNew";
import Separator from "components/Separator";
import get from "lodash/get";

const ShippingRateNewList = ({ name, header }) => {
  const { values } = useFormikContext();
  const firstNameRef = useRef(null);
  useEffect(() => {
    firstNameRef.current && firstNameRef.current.focus();
  }, []);

  const models = get(values, name);
  return (
    <Fragment>
      <FieldArray
        name={name}
        render={(arrayHelpers) => (
          <ul className="list ma0 pa0 w-100 h-100">
            {models.map((_, modelIx) => {
              const isLast = modelIx === models.length - 1;
              const modelName = `${name}[${modelIx}]`;

              const newModelProps = {
                name: modelName,
                modelIx: modelIx,
                arrayHelpers: arrayHelpers,
                header
              };
              if (!modelIx) {
                newModelProps.innerNameRef = firstNameRef;
              }
              return (
                <Fragment key={modelIx}>
                  <ShippingRateNew {...newModelProps} />
                  {!isLast && (
                    <Separator
                      customClasses={{ container: "w-100 ph0 mt2 pv3 dib" }}
                    />
                  )}
                </Fragment>
              );
            })}
          </ul>
        )}
      />
    </Fragment>
  );
};

export default ShippingRateNewList;
